import { GuaranteeFormValues } from 'features/declaration/models/schemas/guaranteeSchema'
import { GuaranteeUpdate } from './request'
import { Guarantee } from './types'
import { CreateOrUpdateGuaranteeRequest, GuaranteeResponse } from '../../../../api/models'

export function toGuaranteeUpdate(transitOperationId: number, index: number, guarantee: GuaranteeFormValues): GuaranteeUpdate {
  return {
    id: guarantee.id,
    sequenceNumber: guarantee.sequenceNumber ?? index,
    transitOperationId,
    nctsProfileId: guarantee.nctsProfileId,
    amount: guarantee.amount,
  }
}

export function toGuaranteeUpdates(transitOperationId: number, guarantees: GuaranteeFormValues[]): GuaranteeUpdate[] {
  return guarantees.map((guarantee, index) => toGuaranteeUpdate(transitOperationId, index, guarantee))
}

export function toRequest(update: GuaranteeUpdate): CreateOrUpdateGuaranteeRequest {
  return {
    id: update.id,
    transitOperationId: update.transitOperationId,
    nctsProfileId: update.nctsProfileId,
    amount: update.amount,
  }
}

export function toRequests(updates: GuaranteeUpdate[]): CreateOrUpdateGuaranteeRequest[] {
  return updates.map((update) => toRequest(update))
}

export function fromGuaranteeResponse(index: number, response: GuaranteeResponse): Guarantee {
  return {
    id: response.id,
    sequenceNumber: index,
    amount: response.amount ?? 0,
    nctsProfileId: response.nctsProfileId,
    deleted: false,
  }
}

export function fromGuaranteeResponses(responses: GuaranteeResponse[]): Guarantee[] {
  return responses.map((response, idx) => fromGuaranteeResponse(idx, response))
}
